// layout
import moment from "jalali-moment";
import Notfound from "../Components/Common/Notfound";
import MainLayout from "../Container/Layout/MainLayout";
import { Context } from "../Context/Context";
// style
import styles from "../Styles/Factors.module.css";
// component
import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { getFactor, getPaymentPageURL } from "../Services/ContectService";

const Factors = () => {
  const { json, loading, setLoading, user } = useContext(Context);
  const [data, setData] = useState();
  let params = useParams();
  const navigate = useNavigate();

  const getDetailfactorHandeler = async () => {
    setLoading(true);
    try {
      const { status, data } = await getFactor(user, params.id);
      if (status === 200) {
        setData(data);
      }
    } catch (error) {
      toast.error(json.toast.err_1);
    } finally {
      setLoading(false);
    }
  };

  const goToPayPage = async () => {
    setLoading(true);
    try {
      const response = await getPaymentPageURL(user, params.id);
      if (response.status === 200) {
        window.location.replace(response.data.url);
      }
    } catch (error) {
      toast.error(json.toast.err_1);
      setLoading(false);
    }
  };

  useEffect(() => {
    getDetailfactorHandeler();
  }, []);

  return (
    <MainLayout>
      <section className={styles.section_factor}>
        <div className={styles.info_pay}>
          <div className={styles.item_info_pay}>
            <h3 className="bold w-100 text-h5">نحوه ارسال</h3>
            <div>
              <span>پست</span>
              <svg
                viewBox="0 0 19 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.8176 2.31943H6.38124C3.58551 2.31943 1.91882 3.98611 1.91882 6.78184V13.2105C1.91882 16.0139 3.58551 17.6806 6.38124 17.6806H12.8099C15.6056 17.6806 17.2723 16.0139 17.2723 13.2182V6.78184C17.28 3.98611 15.6133 2.31943 12.8176 2.31943ZM13.2707 8.23347L8.91583 12.5884C8.8083 12.6959 8.66237 12.7573 8.50876 12.7573C8.35514 12.7573 8.20921 12.6959 8.10169 12.5884L5.92808 10.4148C5.70535 10.192 5.70535 9.82335 5.92808 9.60061C6.15082 9.37788 6.51949 9.37788 6.74222 9.60061L8.50876 11.3671L12.4566 7.41933C12.6793 7.19659 13.048 7.19659 13.2707 7.41933C13.4935 7.64207 13.4935 8.00305 13.2707 8.23347Z"
                  fill="#77D6BF"
                />
              </svg>
            </div>
          </div>
          <div className={styles.item_info_pay}>
            <h3 className="bold w-100 text-h5">نحوه پرداخت</h3>
            <div>
              <span>درگاه بانک ملت</span>
              <svg
                viewBox="0 0 19 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.8176 2.31943H6.38124C3.58551 2.31943 1.91882 3.98611 1.91882 6.78184V13.2105C1.91882 16.0139 3.58551 17.6806 6.38124 17.6806H12.8099C15.6056 17.6806 17.2723 16.0139 17.2723 13.2182V6.78184C17.28 3.98611 15.6133 2.31943 12.8176 2.31943ZM13.2707 8.23347L8.91583 12.5884C8.8083 12.6959 8.66237 12.7573 8.50876 12.7573C8.35514 12.7573 8.20921 12.6959 8.10169 12.5884L5.92808 10.4148C5.70535 10.192 5.70535 9.82335 5.92808 9.60061C6.15082 9.37788 6.51949 9.37788 6.74222 9.60061L8.50876 11.3671L12.4566 7.41933C12.6793 7.19659 13.048 7.19659 13.2707 7.41933C13.4935 7.64207 13.4935 8.00305 13.2707 8.23347Z"
                  fill="#77D6BF"
                />
              </svg>
            </div>
          </div>

          <div className={styles.btn_info_pay}>
            <button type="text" onClick={() => navigate(-1)}>
              بازگشت
            </button>
            <button type="button" onClick={() => goToPayPage()}>
              پرداخت درگاه بانک ملت
            </button>
          </div>
        </div>
        {loading ? (
          <div className="d-flex justify-content-center px-2 py-5 h3">
            لطفاً صبر کنید...
          </div>
        ) : data ? (
          <div className={styles.table_factor}>
            <table>
              <tbody className={styles.thead}>
                <tr>
                  <th colspan="2">فاکتور </th>
                  <th colspan="5">
                    <img src="/imgs/wisercam logo.svg" alt="Wisercam Logo" />
                  </th>
                  <th colspan="2">
                    فاکتور: {data.code}
                    <br />
                    تاریخ:{" "}
                    {moment(data.order_date, "YYYY/MM/DD")
                      .locale("fa")
                      .format("YYYY/MM/DD")}
                  </th>
                </tr>
              </tbody>
              <tbody>
                <tr>
                  <th colspan="9">مشخصات فروشنده</th>
                </tr>
                <tr>
                  <td colspan="3">نام شخص حقیقی/حقوقی: نوید صنعت ویرا</td>
                  <td colspan="3">شماره ملی/اقتصادی: 14012309693</td>
                  <td colspan="3">ایمیل: info@wisercam.com</td>
                </tr>
                <tr>
                  <td colspan="3">استان : تهران</td>
                  <td colspan="3">شهر : تهران</td>
                  <td colspan="3">کد پستی : 1341644652</td>
                </tr>
                <tr>
                  <td colspan="6">
                    آدرس: دفتر مرکزی: تهران، خیابان آزادی، خیابان رجبعلی لعل
                    آخر، بن بست نسترن، پلاک 8، واحد 15
                  </td>
                  <td colspan="9">شماره تماس: 66082941-021</td>
                </tr>
              </tbody>
              <tbody>
                <tr>
                  <th colspan="9"> مشخصات خریدار</th>
                </tr>
                <tr>
                  <td colspan="3">
                    نام شخص حقیقی/حقوقی :{" "}
                    {data.custom_receiver_first_name &&
                    data.custom_receiver_last_name
                      ? `${data.custom_receiver_first_name} ${data.custom_receiver_last_name}`
                      : `${data.user_detail.name} ${data.user_detail.family}`}
                  </td>
                  <td colspan="3">
                    شماره ملی/اقتصادی :{" "}
                    {data.custom_receiver_national_code ||
                      data.user_detail.national_code}
                  </td>
                  <td colspan="3">
                    ایمیل :{" "}
                    {data.custom_receiver_email || data.user_detail.email}
                  </td>
                </tr>
                <tr>
                  <td colspan="3">
                    استان :{" "}
                    {data.custom_receiver_province || data.user_detail.province}
                  </td>
                  <td colspan="3">
                    شهر : {data.custom_receiver_city || data.user_detail.city}
                  </td>
                  <td colspan="3">
                    کد پستی :{" "}
                    {data.custom_receiver_address_code ||
                      data.user_detail.address_code}
                  </td>
                </tr>
                <tr>
                  <td colspan="6">
                    آدرس :{" "}
                    {data.custom_receiver_address || data.user_detail.address}
                  </td>
                  <td colspan="9">
                    شماره تلفن :{" "}
                    {data.custom_receiver_phone_number ||
                      data.user_detail.phone_number}
                  </td>
                </tr>
              </tbody>
              <tbody>
                <tr>
                  <th colspan="9"> مشخصات خدمت/خدمات مورد معامله </th>
                </tr>
                <tr>
                  <td>سطر</td>
                  <td>کد خدمت</td>
                  <td colspan="3">شرح خدمت</td>
                  <td>تعداد</td>
                  <td colspan="2">مبلغ</td>
                </tr>

                {data.services_detail.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item.code}</td>
                    <td colspan="3">
                      <a target="_blank" href="/">
                        ماشین کاری
                      </a>
                    </td>
                    <td>{item.quantity}</td>
                    <td colspan="2">{item.total_price}</td>
                  </tr>
                ))}
              </tbody>
              <tbody>
                <tr>
                  <th colspan="9">مشخصات تکمیلی خرید</th>
                </tr>
                <tr>
                  <td colspan="2">نحوه پرداخت : آنلاین</td>
                  <td colspan="2">هزینه حمل و نقل : {data.transfer_price}</td>
                  <td colspan="2">تخفیف : {data.discount_amount}</td>
                  <td colspan="3">مجموع مبلغ فاکتور : {data.payment_price}</td>
                </tr>
              </tbody>
            </table>
          </div>
        ) : (
          <Notfound />
        )}
      </section>
    </MainLayout>
  );
};

export default Factors;
